import React from 'react'
import Main from '../layout/Main'

const Home = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default Home